__turbopack_context__.v({
  "blockTitle": "Yg8zXq_blockTitle",
  "expandButton": "Yg8zXq_expandButton",
  "linkBlockWrapper": "Yg8zXq_linkBlockWrapper",
  "listBlock": "Yg8zXq_listBlock",
  "listItem": "Yg8zXq_listItem",
});
